export default __webpack_public_path__ + "static/chronos_bckg2-c8d828139b37467490d9c36f2e2eb70a.png";